// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form__main___uKAoh {
	padding-top: 0.5em;
	margin-bottom: 5px;
}

.Form__label___Vzmnz {
	font-size: 9px;
	color: darkgrey;
	position: relative;
}

.Form__labelIcon___FxPYR {
	font-size: 12px;
}

.Form__pressEnterLabelFormInput___Zcpxj {
	position: relative;
	font-size: 14px;
	color: #a9a9a996;
	right: 14px;
	top: 1px;
	margin: -5px;
}

.Form__pressEnterLabelTextArea___ciBD6 {
	position: relative;
	font-size: 14px;
	color: #a9a9a996;
	right: 36px;
	top: -14px;
	margin: -5px;
}

.Form__pressEnterLabelFormSelect___Q06X6 {
	position: relative;
	font-size: 14px;
	color: #a9a9a996;
	right: 9px;
	top: 1px;
	margin: -5px;
}

.Form__textAreaLabel___huC8x {
	position: relative;
	bottom: 12px;
	left: 3px;
}

.Form__formControl____FZS1 {
	margin: 0 0.25em;
	font-size: 16px;
	color: #b3b3b3;
	background: transparent;
	display: inline;
	padding: 6px 12px;
	line-height: 1.42857143;
	border: 0;
	outline: 0;
	border-radius: 4px;
	border-bottom: 1px dotted darkgoldenrod;
	-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
	width: 100%;
	box-shadow: none;
}

.Form__formControl____FZS1:focus {
	box-shadow: gold 0px 0px 7px;
}

.Form__formControlAnimations___TH9tv {
	transition: box-shadow 0.2s;
}

.Form__formControlAnimations___TH9tv:hover {
	box-shadow: darkgoldenrod 0px 0px 10px;
}

.Form__clearInput___x4CKh {
	position: absolute;
	top: 1px;
	color: dimgray;
	right: 8px;
}

.Form__clearTextAreaInput___SGTEf {
	position: relative;
	bottom: 14px;
	color: dimgray;
	right: 24px;
	font-size: 11px;
}

.Form__hidden___Zixld {
	display: none;
}

.Form__noScrollBar___R_pGQ {
	overflow: hidden;
}

.Form__displayBlock___aPe5k {
	display: block;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Form__main___uKAoh`,
	"label": `Form__label___Vzmnz`,
	"labelIcon": `Form__labelIcon___FxPYR`,
	"pressEnterLabelFormInput": `Form__pressEnterLabelFormInput___Zcpxj`,
	"pressEnterLabelTextArea": `Form__pressEnterLabelTextArea___ciBD6`,
	"pressEnterLabelFormSelect": `Form__pressEnterLabelFormSelect___Q06X6`,
	"textAreaLabel": `Form__textAreaLabel___huC8x`,
	"formControl": `Form__formControl____FZS1`,
	"formControlAnimations": `Form__formControlAnimations___TH9tv`,
	"clearInput": `Form__clearInput___x4CKh`,
	"clearTextAreaInput": `Form__clearTextAreaInput___SGTEf`,
	"hidden": `Form__hidden___Zixld`,
	"noScrollBar": `Form__noScrollBar___R_pGQ`,
	"displayBlock": `Form__displayBlock___aPe5k`
};
module.exports = ___CSS_LOADER_EXPORT___;
